import Header from "./Header/Header";
import Navbar from "./Navbar/Navbar";
import Trust from "./Trust/Trust";
import Taisao from "./Why/Taisao";
import Quytrinh from "./Quytrinh/Quytrinh";
import Banner from "./Banner/Banner";
import Danhgia from "./Danhgia/Danhgia";
import Faq from "./Faq/Faq";
import Lienhe from "./Lienhe/Lienhe";
import Footer from "./Footer/Footer";
import Contact from "./Contact/Contact";

export default function Home() {
  return (
    <div>
      <Navbar />
      <Header />
      <Trust />
      <Taisao />
      <Quytrinh />
      <Banner />
      <Danhgia />
      <Faq />
      <Lienhe />
      <Footer />
      <Contact />
    </div>
  );
}
